<template>
    <div class="card" :class="{'hover' : administrator}">
        <div class="header-course">
            <h3>
              {{!administrator ? Ccategory.name : '' }} {{category && !administrator ? category.name : ''}} {{ course.name }}
            </h3>
            <span v-if="!admin">
                {{ course.age }}
            </span>
        </div>
        <div class="content-course" v-if="!admin">
            <div>
                {{ course.day }} {{ course.time }}
            </div>
            <div>
                Professeur {{ course.professor }}
            </div>
            <div>
                {{ course.price }}€/ trimestre
            </div>
        </div>
        <div class="action">
            <div v-if="!alreadyTakeThisCourse">
                <slot name="subscription" />
            </div>
            <div v-else>
                Ce danseur a déjà demandé ce cours
            </div>

            <slot name="action">
            </slot>
        </div>
    </div>
</template>

<script>
    import UniButton from "./UniButton";
    import UniLoadingButton from "../b-patterns/UniLoadingButton";
    export default {
        name: "RichCourseCard",
        components: {UniLoadingButton, UniButton},
        props:{
            course: Object,
            category: Object,
            coursesUserAlreadyTakes: Array,
            admin: {
                type: Boolean,
                default: false
            },
            administrator: {
                type: Boolean,
                default: false
            },
        },
        data(){
          return{
              alreadyTakeThisCourse: false,
              Ccategory: {
                  name: ''
              }
          }
        },
        methods:{
            initTimeCourseValue(){
                let c = this.course
                let amount = parseInt(c.hour / 2)
                let isDemi = ''
                if (c.hour % 2 === 1)
                    isDemi = '30'
                let timeStart = amount + 'h' + isDemi

                let amountEnd = parseInt(c.hour / 2 + c.duration)
                let isDemiEnd = ''
                if ((c.hour + c.duration*2) % 2 === 1)
                    isDemiEnd = "30"
                let timeEnd = amountEnd + 'h' + isDemiEnd
                let time = 'de ' + timeStart + ' à ' + timeEnd
                c.time = time
            },
            hasAlreadyTakeThisCourse(index) {
                if(this.coursesUserAlreadyTakes !== undefined){
                    this.alreadyTakeThisCourse = (this.coursesUserAlreadyTakes.find(x => x.id === index)) !== undefined;
                }
            },
        },
        created(){
            this.initTimeCourseValue()
            this.hasAlreadyTakeThisCourse(this.course.id)

            if (this.category === undefined) {
                this.Ccategory = this.course.course_category
            }
        }
    }
</script>

<style scoped lang="scss">

    .card.hover:hover {
        cursor: pointer;
    }
    .header-course {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    .content-course {
        > div {
            margin-bottom: 2px;
        }

        margin-bottom: 8px;
    }

    .action{
        /deep/ button{
            width: 100%;
        }
    }

</style>
